import { render } from "./BlockSubtitle.vue?vue&type=template&id=47d45b30"
import script from "./BlockSubtitle.vue?vue&type=script&lang=js"
export * from "./BlockSubtitle.vue?vue&type=script&lang=js"

import "./BlockSubtitle.vue?vue&type=style&index=0&id=47d45b30&lang=scss"
script.render = render

export default script